<template>
  <div class="body-bg">
    <div class="under"></div>
    <div class="above">
      <div class="head">
        <div style="width:70%;margin:auto;display: flex;background: white">
          <div style="width:30%">
            <img src="../../assets/img/logo/logo11.png" style="margin-left:5px;width:140px">
          </div>
          <div style="width:70%;float:right">
            <!--<el-tabs @tab-click="handleClick">
              &lt;!&ndash;<img src="../../assets/img/logo/logo.jpg" style="width:100px;">&ndash;&gt;
              <el-tab-pane label="主页" name="1"></el-tab-pane>
              <el-tab-pane label="产品介绍" name="2"></el-tab-pane>
              <el-tab-pane label="公告通知" name="3"></el-tab-pane>
              <el-tab-pane label="关于我们" name="4"></el-tab-pane>
              <el-tab-pane label="经销商登录" name="5"></el-tab-pane>
            </el-tabs>-->
            <el-menu :default-active="defaultactive" class="el-menu-demo" mode="horizontal" @select="handleClick">
              <el-menu-item index="1">主页</el-menu-item>
              <el-submenu index="2">
                <template slot="title">产品介绍</template>
                <el-menu-item index="2-1">LX-B-240-25  壁挂式等离子空气消毒机</el-menu-item>
                <el-menu-item index="2-2">HCA-02100A 壁挂/落地式等离子空气消毒机</el-menu-item>
                <el-menu-item index="2-3">HCB-02200A 车载/台面式等离子空气消毒机</el-menu-item>
                <el-menu-item index="2-4">LX-C-100-5FJ 车载式等离子空气消毒机</el-menu-item>
              </el-submenu>
              <el-menu-item index="3">公告通知</el-menu-item>
              <el-menu-item index="4">关于我们</el-menu-item>
              <el-menu-item index="5">经销商登录</el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
      <div class="body">
        <div v-if="showZY">
          <div style="background: rgb(223 225 234);padding-top: 20px;padding-bottom: 20px">
            <div style="width:65%;margin: auto;text-align: center">
              <span style="font-size:50px;color:#4747b5">海柯蓝</span><br>
              <span style="font-size:25px;color:rgb(81 162 136)">About Heclar</span>
            </div>
            <div style="width:65%;margin: auto;margin-top: 20px">
              <p style="text-indent:2em;"><span style="line-height: 1.8em;font-size: 14px;color:#444">   Heclar海柯蓝作为医用级高端空气消毒净化方案提供商，2015年米兰世博会中国国家馆唯一指定空气净化产品，公司拥有强大的研发团队和多项产品专利技术。</span></p>
              <p style="text-indent:2em;"><span style="line-height: 1.8em;font-size: 14px;color:#444">   推出的“海柯蓝高端高密度等离子空气消毒机”系列产品，已成功应用于轨道交通京张线、京雄线客车室空气净化消毒，在疫情前线的武汉急救车、温州急救车上24小时持续消杀，降低医护人员感染几率，得到全国几十家医院认可。</span></p>
              <p style="text-indent:2em;"><span style="line-height: 1.8em;font-size: 14px;color:#444">   “海柯蓝高端高密度等离子空气消毒机”是拥有自主知识产权，结合德国和国内创新HI-PLAS高密度等离子技术的高端优质产品，目前已通过全国消毒产品网上备案。</span></p>
            </div>
          </div>
          <div style="display: flex;margin-top: 20px">
            <div style="width: 20%;margin-left: 3%;text-align: center">
              <span class="demonstration" style="font-size: 16px;line-height: 25px">HCA-02100A<br/> 壁挂/落地式等离子空气消毒机<br/><span style="color:#bb671f;font-weight:900">统一零售价：19800</span></span>
              <el-image style="margin-top: 10px" :src="require('@/assets/img/product/product2.jpg')" @click="handleClick('2-2')"></el-image>
            </div>
            <div style="width: 20%;margin-left: 6%;text-align: center">
              <span class="demonstration" style="font-size: 16px;line-height: 25px">LX-B-240-25<br/>  壁挂式等离子空气消毒机<br/><span style="color:#bb671f;font-weight:900">统一零售价：37000</span></span>
              <el-image style="margin-top: 10px" :src="require('@/assets/img/product/product1.jpg')" @click="handleClick('2-1')"></el-image>
            </div>
            <div style="width: 20%;margin-left: 3%;text-align: center">
              <span class="demonstration" style="font-size: 16px;line-height: 25px">HCB-02200A<br/> 车载/台面式等离子空气消毒机<br/><span style="color:#bb671f;font-weight:900">统一零售价：19800</span></span>
              <el-image style="margin-top: 10px" :src="require('@/assets/img/product/product3.jpg')" @click="handleClick('2-3')"></el-image>
            </div>
            <div style="width: 20%;margin-left: 3%;text-align: center">
              <span class="demonstration" style="font-size: 16px;line-height: 25px">LX-C-100-5FJ<br/> 车载式等离子空气消毒机<br/><span style="color:#bb671f;font-weight:900">统一零售价：28500</span></span>
              <el-image style="margin-top: 10px" :src="require('@/assets/img/product/product4.jpg')" @click="handleClick('2-4')"></el-image>
            </div>
          </div>
        </div>
        <div v-if="showCPJS1">
          <div class="GYWM">
            <div class="demo-image__lazy">
              <el-image :key="require('@/assets/img/product/product1/01.jpg')" :src="require('@/assets/img/product/product1/01.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/02.jpg')" :src="require('@/assets/img/product/product1/02.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/03.jpg')" :src="require('@/assets/img/product/product1/03.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/04.jpg')" :src="require('@/assets/img/product/product1/04.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/05.jpg')" :src="require('@/assets/img/product/product1/05.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/06.jpg')" :src="require('@/assets/img/product/product1/06.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/07.jpg')" :src="require('@/assets/img/product/product1/07.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/08.jpg')" :src="require('@/assets/img/product/product1/08.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product1/09.jpg')" :src="require('@/assets/img/product/product1/09.jpg')" lazy></el-image>
            </div>
            <!--<img src="../../assets/img/usercenter/product1.jpg" style="width:100%;">-->
          </div>
        </div>
        <div v-if="showCPJS2">
          <div class="GYWM">
            <div class="demo-image__lazy">
              <el-image :key="require('@/assets/img/product/product2/01.jpg')" :src="require('@/assets/img/product/product2/01.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product2/02.jpg')" :src="require('@/assets/img/product/product2/02.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product2/03.jpg')" :src="require('@/assets/img/product/product2/03.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product2/04.jpg')" :src="require('@/assets/img/product/product2/04.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product2/05.jpg')" :src="require('@/assets/img/product/product2/05.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product2/06.jpg')" :src="require('@/assets/img/product/product2/06.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product2/07.jpg')" :src="require('@/assets/img/product/product2/07.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product2/08.jpg')" :src="require('@/assets/img/product/product2/08.jpg')" lazy></el-image>
            </div>
            <!--<img src="../../assets/img/usercenter/product2.jpg" style="width:100%;">-->
          </div>
        </div>
        <div v-if="showCPJS3">
          <div class="GYWM">
            <div class="demo-image__lazy">
              <el-image :key="require('@/assets/img/product/product3/01.jpg')" :src="require('@/assets/img/product/product3/01.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/02.jpg')" :src="require('@/assets/img/product/product3/02.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/03.jpg')" :src="require('@/assets/img/product/product3/03.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/04.jpg')" :src="require('@/assets/img/product/product3/04.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/05.jpg')" :src="require('@/assets/img/product/product3/05.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/06.jpg')" :src="require('@/assets/img/product/product3/06.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/07.jpg')" :src="require('@/assets/img/product/product3/07.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/08.jpg')" :src="require('@/assets/img/product/product3/08.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/09.jpg')" :src="require('@/assets/img/product/product3/09.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product3/10.jpg')" :src="require('@/assets/img/product/product3/10.jpg')" lazy></el-image>
            </div>
            <!--<img src="../../assets/img/usercenter/product2.jpg" style="width:100%;">-->
          </div>
        </div>
        <div v-if="showCPJS4">
          <div class="GYWM">
            <div class="demo-image__lazy">
              <el-image :key="require('@/assets/img/product/product4/01.jpg')" :src="require('@/assets/img/product/product4/01.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/02.jpg')" :src="require('@/assets/img/product/product4/02.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/03.jpg')" :src="require('@/assets/img/product/product4/03.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/04.jpg')" :src="require('@/assets/img/product/product4/04.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/05.jpg')" :src="require('@/assets/img/product/product4/05.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/06.jpg')" :src="require('@/assets/img/product/product4/06.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/07.jpg')" :src="require('@/assets/img/product/product4/07.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/08.jpg')" :src="require('@/assets/img/product/product4/08.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/09.jpg')" :src="require('@/assets/img/product/product4/09.jpg')" lazy></el-image>
              <el-image :key="require('@/assets/img/product/product4/10.jpg')" :src="require('@/assets/img/product/product4/10.jpg')" lazy></el-image>
            </div>
            <!--<img src="../../assets/img/usercenter/product2.jpg" style="width:100%;">-->
          </div>
        </div>
        <div v-if="showGGTZ" style="width:100%;height:100%">
          <div class="GGTZ">
            <img src="../../assets/img/logo/news.jpg" style="width:100%;">
            <div style="display: flex;margin-top: 20px">
              <div style="width:25%">
                <div>
                  <!--<span style="line-height:38px;font-size: 18px;color: white">通知公告</span>-->
                  <el-menu
                          default-active="2"
                          default-openeds="[2]"
                          @open="handleOpen"
                          @close="handleClose"
                          text-color="black"
                          active-text-color="#6cadc8"
                          @select="changetype"

                  >
                    <el-submenu index="2">
                      <template slot="title">
                        <i class="el-icon-menu"></i>
                        <span>通知与公告</span>
                      </template>
                      <el-menu-item-group>
                        <el-menu-item index="0">通知</el-menu-item>
                        <el-menu-item index="1">公告</el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
              <div style="width:75%;padding-right: 30px;">
                <div class="content" style="min-height:500px">
                  <li>
                    <span style="float:left;font-size: 18px;color:#6cadc8">{{selecttype}}标题</span>
                    <span style="float:right">日期</span>
                  </li>
                  <el-divider></el-divider>
                  <ul>
                    <li v-for="(item,index) in dataSet" :key="index">
                      <span style="float:left" @click="opennews(item)">{{item.newstitle}}</span>
                      <span style="float:right;color:#9C9C9C">{{item.createtime}}</span>
                    </li>
                  </ul>
                </div>
                <div style="float:right">
                  <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :page-size="pageSize"
                          layout="prev, pager, next, jumper"
                          :total="total">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showGYWM">
          <div class="GYWM">
            <img src="../../assets/img/usercenter/Merchants.jpg" style="width:100%;">
            <!--<el-image :src="require('../../assets/img/usercenter/Merchants.jpg')" lazy/>-->
          </div>
        </div>
        <!--<div style="margin: auto;width:70%">
          <div style="width:40%">
            <img src="../../assets/img/logo/logo.png" style="margin-left:5px;width:140px">
          </div>
          <div>
            <span>海柯蓝</span>
          </div>
        </div>-->
      </div>
      <div class="footer">
        <div style="width:60%;margin:auto;padding-top: 60px;display: flex">
          <div style="width:30%;line-height:32px;">
            <p>招商热线: </p>
            <p>王经理：18118390330</p>
            <p>童经理：13761764673</p>
            <p>邮箱地址：tongmin@well-tech-china.com</p>
          </div>
          <div style="width:40%;line-height:32px;">
            <p>邮政编码：213031</p>
            <p><a href="http://well-tech-china.com:1887/dist/#/home">网站地址：http://well-tech-china.com:1887/dist/#/home</a></p>
            <p>办公地址：江苏省常州市新北区新科路8号</p>
          </div>
          <div style="width:30%;line-height:32px;">
            <el-image style="width:150px" :src="require('@/assets/img/logo/logo11.png')"></el-image>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import Mock from 'mockjs'
export default {
    data() {
        return {
            src: "../../assets/img/usercenter/Merchants.jpg",
            showZY: true,
            showCPJS1: false,
            showCPJS2: false,
            showCPJS3: false,
            showCPJS4: false,
            showGGTZ: false,
            showGYWM: false,
            dataSet: [],
            pageIndex: 1, // 当前页
            pageSize: 10, // 当前页数据量
            total: 0, // 数据总量
            newstype: '0', //类别 0通知 1公告 ,
            product1: "@/assets/img/product/product1.jpg",
            product2: "@/assets/img/product/product2.jpg",
            product3: "@/assets/img/product/product3.jpg",
            product4: "@/assets/img/product/product4.jpg",
            defaultactive: '1',
            selecttype: '通知'
        }
    },
    mounted() {
        let that = this
        that.getView()
    },
    methods: {
        changetype(value) {
            let that = this
            that.newstype = value
            if(value == 0){
                that.selecttype = '通知'
            } else if(value == 1){
                that.selecttype = '公告'
            }
            that.getView()
        },
        handleOpen(key, keyPath) {
        },
        handleClose(key, keyPath) {
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getView();
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getView();
        },
        getView(){
            let that = this
            let parm = {
                PageSize: that.pageSize,
                PageIndex: that.pageIndex,
                QueryKey: "",
                iid: "",
                newstype: that.newstype
            };
            that.$http.urlpost1('/SysNews/View', parm, function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.total = res.Totals;
                } else {
                    that.$message.error(res.Msg);
                }
            });
        },
        redirection() {
            let that = this
            that.$router.push({ path: '/dlogin' });
        },
        handleClick(tab, event) {
            let that = this
            that.defaultactive = tab
            if(tab == 1){
                that.showZY = true,
                that.showCPJS1 = false,
                that.showCPJS2 = false,
                that.showCPJS3 = false,
                that.showCPJS4 = false,
                that.showGGTZ = false,
                that.showGYWM = false
            } else if(tab == '2-1') {
                that.showZY = false,
                that.showCPJS1 = true,
                that.showCPJS2 = false,
                that.showCPJS3 = false,
                that.showCPJS4 = false
                that.showGGTZ = false,
                that.showGYWM = false
            } else if(tab == '2-2'){
                that.showZY = false,
                that.showCPJS1 = false,
                that.showCPJS2 = true,
                that.showCPJS3 = false,
                that.showCPJS4 = false,
                that.showGGTZ = false,
                that.showGYWM = false
            } else if(tab == '2-3'){
                that.showZY = false,
                that.showCPJS1 = false,
                that.showCPJS2 = false,
                that.showCPJS3 = true,
                that.showCPJS4 = false,
                that.showGGTZ = false,
                that.showGYWM = false
            } else if(tab == '2-4'){
                that.showZY = false,
                that.showCPJS1 = false,
                that.showCPJS2 = false,
                that.showCPJS3 = false,
                that.showCPJS4 = true,
                that.showGGTZ = false,
                that.showGYWM = false
            }else if(tab == 3) {
                that.showZY = false,
                that.showCPJS1 = false,
                that.showCPJS2 = false,
                that.showCPJS3 = false,
                that.showCPJS4 = false,
                that.showGGTZ = true,
                that.showGYWM = false
            } else if(tab == 4){
                that.showZY = false,
                that.showCPJS1 = false,
                that.showCPJS2 = false,
                that.showCPJS3 = false,
                that.showCPJS4 = false,
                that.showGGTZ = false,
                that.showGYWM = true
            } else if(tab == 5){
                that.redirection()
            }
        },
        opennews(data){
            let routeUrl = this.$router.resolve({
                path: '/news',
                query: {
                    title:data.newstitle,
                    content: data.newscontent
                }
            });
            window.open(routeUrl.href, '_blank');
        }
    }

}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/home';
.body-bg{
  position: absolute;
  height: 100%;
  width: 100%;
  top:0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;//背景色为白色
}
.under{
  width:100%;
  position:absolute;
  z-index:100;
  background: rgba(0, 0, 0, 0.6);
  /*background: url("../../assets/img/usercenter/bg.png");
  background-size: 100% 100%;
  -webkit-filter: blur(6px);
  filter: blur(6px);
  opacity: 0.8;*/
}
.above{
  width:100%;
  position:absolute;
  z-index:300;
}
/*@media screen and (max-width: 2000px) {
  .GYWM {
    width: 60%;
    height:900px;
    overflow: auto;
    margin: auto;
  }
}
@media screen and (max-width: 1601px) {
  .GYWM {
    width: 60%;
    height:750px;
    overflow: auto;
    margin: auto;
  }
}*/
.head{
}
.GYWM {
  width: 60%;
  /*height:900px;
  overflow: auto;*/
  margin: auto;
}
::v-deep body{
  height:auto;
  min-height: 100%;
}
::v-deep .el-tabs__header.is-top {
  height: 80px;
  line-height: 60px;
}
::v-deep .el-tabs__item {
  font-size: 18px !important;
}
.GGTZ{
  width:70%;
  height: 100%;
  margin: auto;
  background: white;
}
.content li{
    /*display: flex;*/
    align-items: center;
  /*justify-content: center;*/
    height: 40px;
    /*background: #e8f3fe;*/
    margin: 10px;
    font-size: 15px ;
    /*color: #7dbcfc;*/
}
.footer{
  margin-top: 20px;
  background: rgb(223 225 234);
  height:200px;
}
::v-deep .el-carousel__container {
  position: relative;
  height: 700px;
  .el-carousel__item--card.is-active {
    overflow: auto;
  }
}
.el-menu-item{
  font-size: 18px
}
::v-deep .el-submenu__title{
  font-size: 18px;
}
</style>
